/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var e = /* @__PURE__ */ ((T) => (T.TOP = "top", T.BOTTOM = "bottom", T.LEFT = "left", T.RIGHT = "right", T.NONE = "none", T))(e || {});
export {
  e as toolbarPosition
};
